// extracted by mini-css-extract-plugin
export default {"wrapper":"MetricBox_wrapper__Ra4DE","icon":"MetricBox_icon__xlX-8","title":"MetricBox_title__v-F2E","value":"MetricBox_value__y0pvF","subtitle":"MetricBox_subtitle__qxhEM"};